export const EXTERNAL_USER_ID = 11
export const SUPER_ADMIN = 2
export const COUNSELOR = 5
export const LEADS_BOT_ID = 4
